<template>
  <div class="rating-hovered">
    <div class="supplier-main">
      <div class="supplier-main-title">
        Supplier Credit Rating
      </div>
      <div class="product-star">
        <div
          class="product-star-img"
          v-if="offerData?.sellerDataInfo?.compositeServiceScore"
        >
          <img
            src="@/assets/colorIcon/star.svg"
            alt=""
            v-for="i in new Array(Math.floor(offerData?.sellerDataInfo?.compositeServiceScore)).fill(0)"
          >
          <img
            src="@/assets/star-no.svg"
            alt=""
            v-for="i in new Array(Math.ceil(5 - offerData?.sellerDataInfo?.compositeServiceScore)).fill(0)"
          >
        </div>
        <div class="product-star-cost">
          ({{ offerData?.sellerDataInfo?.compositeServiceScore }})
        </div>
      </div>
      <div class="supplier-product">
        <div class="supplier-pd-item">
          <div class="supplier-pd-label">
            Trade Medal Level
          </div>
          <div class="supplier-pd-value">
            <div class="supplier-pd-line">
              <div
                :style="getItemStyle(offerData?.sellerDataInfo?.tradeMedalLevel)"
                class="supplier-pd-line-percent"
              />
            </div>
            <div class="supplier-pd-score">
              ({{ offerData?.sellerDataInfo?.tradeMedalLevel }})
            </div>
          </div>
        </div>
        <div class="supplier-pd-item">
          <div class="supplier-pd-label">
            Quality Experience
          </div>
          <div class="supplier-pd-value">
            <div class="supplier-pd-line">
              <div
                :style="getItemStyle(offerData?.sellerDataInfo?.offerExperienceScore)"
                class="supplier-pd-line-percent"
              />
            </div>
            <div class="supplier-pd-score">
              ({{ offerData?.sellerDataInfo?.offerExperienceScore }})
            </div>
          </div>
        </div>
        <div class="supplier-pd-item">
          <div class="supplier-pd-label">
            Composite Service
          </div>
          <div class="supplier-pd-value">
            <div class="supplier-pd-line">
              <div
                :style="getItemStyle(offerData?.sellerDataInfo?.compositeServiceScore)"
                class="supplier-pd-line-percent"
              />
            </div>
            <div class="supplier-pd-score">
              ({{ offerData?.sellerDataInfo?.compositeServiceScore }})
            </div>
          </div>
        </div>
        <div class="supplier-pd-item">
          <div class="supplier-pd-label">
            Dispute Complaint
          </div>
          <div class="supplier-pd-value">
            <div class="supplier-pd-line">
              <div
                :style="getItemStyle(offerData?.sellerDataInfo?.disputeComplaintScore)"
                class="supplier-pd-line-percent"
              />
            </div>
            <div class="supplier-pd-score">
              ({{ offerData?.sellerDataInfo?.disputeComplaintScore }})
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  offerData: Object
})

const offerData = props.offerData

const getItemStyle = (item) => {
  return {
    width: (item / 5) * 120 + 'px'
  }
}

</script>

<style lang="less" scoped>
.rating-hovered {
  .supplier-main {
    .supplier-main-title {
      color: #232323;
      font-size: 12px;
      font-family: mon-600;
      line-height: 16px;
    }
    .product-star {
      display: flex;
      justify-content: space-between;
      margin-top: 4px;
      align-items: center;
      .product-star-img {
        img {
          width: 14px;
          height: 14px;
        }
      }
      .product-star-cost {
        font-size: 12px;
        font-family: mon-500;
        line-height: 16px;
        color: #232323;
        margin-left: 4px;
      }
    }
    .supplier-product {
      margin-top: 2px;
      .supplier-pd-item {
        margin-top: 6px;
        .supplier-pd-label {
          font-size: 10px;
          line-height: 14px;
          font-family: 500;
          color: #6E717A;
        }
        .supplier-pd-value {
          margin-top: 2px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .supplier-pd-line {
            width: 120px;
            height: 6px;
            border-radius: 4px;
            background-color: #EBEBEB;
            position: relative;
            .supplier-pd-line-percent {
              position: absolute;
              height: 6px;
              background-color: #F57231;
              border-radius: 4px;
            }
          }
          .supplier-pd-score {
            color: #6E717A;
            font-size: 10px;
            line-height: 14px;
            font-family: mon-500;
          }
        }
      }
    }
  }
}
</style>
